import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { API } from '../config/api';

export default function CoachActivation() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get('token');
  const [info, setInfo] = useState(null);
  const [error, setError] = useState(null);
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setError('Lien invalide.'); return; }
    axios.get(`${API}/coach/activation/${token}`)
      .then((r) => setInfo(r.data))
      .catch((e) => setError(e.response?.data?.detail || 'Lien invalide ou expiré.'));
  }, [token]);

  const activate = async () => {
    if (pw.length < 8) return toast.error('8 caractères minimum.');
    if (pw !== pw2) return toast.error('Les mots de passe ne correspondent pas.');
    setBusy(true);
    try {
      await axios.post(`${API}/coach/activate`, { token, password: pw });
      toast.success('Espace Coach activé ! Connectez-vous pour compléter votre profil.');
      navigate('/login');
    } catch (e) { toast.error(e.response?.data?.detail || 'Erreur.'); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#F5EFE5] flex items-center justify-center px-4" data-testid="coach-activation-page">
      <div className="max-w-md w-full bg-white border border-[#E9DDCC] rounded-2xl p-8">
        <p className="text-[10px] uppercase tracking-[0.3em] text-[#9A744C] font-semibold mb-2 text-center">Équipe PURO</p>
        <h1 className="font-heading text-2xl text-[#493329] text-center mb-6">Activation de votre espace Coach</h1>
        {error && <p className="text-sm text-[#C76542] text-center" data-testid="activation-error">{error}</p>}
        {!error && !info && <div className="flex justify-center"><Loader2 className="w-5 h-5 animate-spin text-[#C99A55]" /></div>}
        {info && (
          <div className="space-y-4">
            <p className="text-sm text-[#7A6455] text-center">Bienvenue <strong className="text-[#493329]">{info.name}</strong>.<br />Créez votre mot de passe pour activer votre espace.</p>
            <Input type="password" placeholder="Mot de passe (8 caractères min.)" value={pw} onChange={(e) => setPw(e.target.value)} className="rounded-xl border-[#E9DDCC] h-11" data-testid="activation-password" />
            <Input type="password" placeholder="Confirmez le mot de passe" value={pw2} onChange={(e) => setPw2(e.target.value)} className="rounded-xl border-[#E9DDCC] h-11" data-testid="activation-password2" />
            <Button onClick={activate} disabled={busy} className="w-full bg-[#9A744C] hover:bg-[#493329] text-white rounded-xl h-11" data-testid="activation-submit">
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Activer mon espace Coach'}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
